import { gql } from 'graphql-request';

export type SpeciesListItem = {
    scientificName: string;
    commonName: string | null;
    iucnRedListCategory: string;
    siteCount: number;
    predictionCreatedAt: string;
    predictionLastUpdated: string;
};

export type PaginatedSpeciesListResponse = {
    species: SpeciesListItem[];
    pagination: {
        page: number;
        pageSize: number;
        total: number;
    };
};

export type PredictedSpeciesTotals = {
    totalSpeciesCount: number;
    numberSites: number;
    lastPredictionRun: string | null;
    predictionRunHistory: { predictionRunDate: string }[];
    redListSpeciesCount: number;
    invasiveSpeciesCount: number;
};

export const redListSpeciesListQuery = gql`
    query getRedListSpeciesList(
        $customerId: String!
        $filters: [CustomFilterOptionInput]
        $pagination: PaginationInput!
        $sortBy: SortByInput
    ) {
        portfolio {
            getRedListSpeciesList(customerId: $customerId, filters: $filters, pagination: $pagination, sortBy: $sortBy) {
                species {
                    scientificName
                    commonName
                    iucnRedListCategory
                    siteCount
                    predictionCreatedAt
                    predictionLastUpdated
                }
                pagination {
                    page
                    pageSize
                    total
                }
            }
        }
    }
`;

export const invasiveSpeciesListQuery = gql`
    query getInvasiveSpeciesList(
        $customerId: String!
        $filters: [CustomFilterOptionInput]
        $pagination: PaginationInput!
        $sortBy: SortByInput
    ) {
        portfolio {
            getInvasiveSpeciesList(customerId: $customerId, filters: $filters, pagination: $pagination, sortBy: $sortBy) {
                species {
                    scientificName
                    commonName
                    iucnRedListCategory
                    siteCount
                    predictionCreatedAt
                    predictionLastUpdated
                }
                pagination {
                    page
                    pageSize
                    total
                }
            }
        }
    }
`;

export const predictedSpeciesTotalsQuery = gql`
    query getPredictedSpeciesTotals($customerId: String!, $filters: [CustomFilterOptionInput]) {
        portfolio {
            getPredictedSpeciesTotals(customerId: $customerId, filters: $filters) {
                totalSpeciesCount
                numberSites
                lastPredictionRun
                predictionRunHistory {
                    predictionRunDate
                }
                redListSpeciesCount
                invasiveSpeciesCount
            }
        }
    }
`;

export type RedListSpeciesListQueryResult = {
    portfolio: {
        getRedListSpeciesList: PaginatedSpeciesListResponse;
    };
};

export type InvasiveSpeciesListQueryResult = {
    portfolio: {
        getInvasiveSpeciesList: PaginatedSpeciesListResponse;
    };
};

export type PredictedSpeciesTotalsQueryResult = {
    portfolio: {
        getPredictedSpeciesTotals: PredictedSpeciesTotals;
    };
};

export const speciesDetailQuery = gql`
    query getSpeciesDetail($customerId: String!, $scientificName: String!, $filters: [CustomFilterOptionInput]) {
        portfolio {
            getSpeciesDetail(customerId: $customerId, scientificName: $scientificName, filters: $filters) {
                scientificName
                commonName
                assessments {
                    projectName
                    isInvasive
                    country
                    predictionScore
                    predictionLevel
                    hasEDNAData
                    hasUploadedData
                    foundInEDNA
                    foundInUploadedData
                    lastUpdated
                }
            }
        }
    }
`;

export type SpeciesDetailQueryResult = {
    portfolio: {
        getSpeciesDetail: {
            scientificName: string;
            commonName: string;
            assessments: {
                projectName: string;
                isInvasive: boolean;
                country: string;
                predictionScore: number;
                predictionLevel: string;
                hasEDNAData: boolean;
                hasUploadedData: boolean;
                foundInEDNA: boolean;
                foundInUploadedData: boolean;
                lastUpdated: string;
            }[];
        };
    };
};
